module.exports = __webpack_public_path__ + "static/media/tc.3886447a.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/tc.svg
// module id = 1168
// module chunks = 0